import type { ImgHTMLAttributes } from 'react';
import type { MediaAsset, MediaFormat } from '../types/content';
import { disclosureLabel } from '../lib/transparency';

interface ResponsiveImageProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'srcSet'> {
  media: MediaAsset;
  sizes?: string;
  priority?: boolean;
}

export function ResponsiveImage({ media, sizes = '100vw', priority = false, className, alt = media.alt, ...props }: ResponsiveImageProps) {
  const sources = (['avif', 'webp'] as MediaFormat[])
    .map((format) => ({ format, variants: media.variants.filter((variant) => variant.format === format) }))
    .filter(({ variants }) => variants.length > 0);

  return (
    <><picture>
      {sources.map(({ format, variants }) => (
        <source
          key={format}
          type={`image/${format}`}
          srcSet={variants.map((variant) => `${variant.src} ${variant.width}w`).join(', ')}
          sizes={sizes}
        />
      ))}
      <img
        {...props}
        className={className}
        src={media.original}
        alt={alt}
        width={media.width}
        height={media.height}
        loading={priority ? 'eager' : 'lazy'}
        fetchPriority={priority ? 'high' : 'auto'}
        decoding={priority ? 'sync' : 'async'}
      />
    </picture>{disclosureLabel(media) && <span className="ai-disclosure">{disclosureLabel(media)}</span>}</>
  );
}
